/*
 * Author: Harper Yan
 * File Created: Sunday, 24-07-21 10:43 am
 * Last Modified: Monday, 25-03-17 03:18 pm, by Harper Yan
 */

import type { SyntheticEvent } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import type { BottomNavigationProps } from '@mui/material';
import { Icon } from '@ucard/ds/Icon';
import { NavBarItems } from './config';
import { StyledBottomNavigation, StyledBottomNavigationAction } from './style';
export const NavBar = (props: BottomNavigationProps) => {
  const {
    t
  } = useTranslation('common');
  const router = useRouter();
  const handleChange = (_e: SyntheticEvent, value: string) => {
    router.push(value);
  };
  return <StyledBottomNavigation onChange={handleChange} showLabels {...props} value={router.pathname} data-sentry-element="StyledBottomNavigation" data-sentry-component="NavBar" data-sentry-source-file="index.tsx">
      {NavBarItems.map(itm => <StyledBottomNavigationAction icon={<Icon gutter name={itm.icon} />} key={itm.label} label={t(itm.label)} value={itm.href} />)}
    </StyledBottomNavigation>;
};